import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { forwardRef as e } from "react";
const t = ({
  title: l,
  titleId: a,
  ...h
}, r) => /* @__PURE__ */ f("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: r, "aria-labelledby": a, ...h, children: [
  l ? /* @__PURE__ */ i("title", { id: a, children: l }) : null,
  /* @__PURE__ */ f("g", { clipPath: "url(#a)", children: [
    /* @__PURE__ */ i("path", { fill: "#fff", d: "M12 18.11v4.483A8.352 8.352 0 0 1 12 5.89V1.407a8.352 8.352 0 0 1 0 16.703" }),
    /* @__PURE__ */ i("path", { fill: "#ff0420", d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 18.11v4.483A8.352 8.352 0 0 1 12 5.89V1.407a8.352 8.352 0 0 1 0 16.703m4.132-6.149v.078a8.88 8.88 0 0 0-4.093 4.093h-.078a8.88 8.88 0 0 0-4.093-4.093v-.078a8.88 8.88 0 0 0 4.093-4.093h.078a8.88 8.88 0 0 0 4.093 4.093" })
  ] }),
  /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "a", children: /* @__PURE__ */ i("rect", { width: 24, height: 24, fill: "#fff", rx: 12 }) }) })
] }), s = e(t);
export {
  s as default
};
//# sourceMappingURL=optimismSepolia.js.map
